var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'checkbox',
		{'checkbox--with-description': _vm.checkbox.description},
		{'is-checked': _vm.checkbox.isChecked},
		{'is-disabled': _vm.checkbox.isDisabled}
	]},[_c('div',{staticClass:"checkbox__sign"}),_vm._v(" "),_c('div',{staticClass:"checkbox__txt"},[_vm._v(_vm._s(_vm.checkbox.txt))]),_vm._v(" "),(_vm.showDescription && _vm.checkbox.description)?_c('div',{staticClass:"checkbox__description"},[_vm._v(_vm._s(_vm.checkbox.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }